module.exports = "<h2 class=\"ui header\">\n  <i class=\"cubes icon\"></i>\n  <div class=\"content\">\n    Issue Client    \n    <div class=\"sub header\">Angular2 Electron Issue Client</div>\n  </div>\n</h2>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/component/header/logo/header-logo.cmp.html
 ** module id = 381
 ** module chunks = 0
 **/